import { EGameStatus } from '@lbs/shared-rp-types'
import { z } from 'zod'

export const RpGameSchema = z.object({
  name: z.string().min(1, { message: 'Имя обязательно' }),
  status: z.nativeEnum(EGameStatus),
  dealer: z.string().refine((val) => val !== '', { message: 'Дилер обязателен' }),
  player: z.string().refine((val) => val !== '', { message: 'Игрок обязателен' }),
  limit: z.number().refine((val) => val !== -1 && val > 0, { message: 'Лимит обязателен' }),
  stand: z.number().refine((val) => val !== -1 && val > 0, { message: 'Стойка обязательна' }),
  bonus: z.number().refine((val) => val !== -1 && val > 0, { message: 'Бонус обязателен' }),
  payout: z.number().refine((val) => val !== -1 && val > 0, { message: 'Выплаты обязательны' }),
})

export type TRpGameFormData = z.infer<typeof RpGameSchema>
